import api from './api';
import type { MatrizUsuario, PermisoCatalogo } from '../types/permisos';

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

export function extractGranted(data: unknown): string[] {
  if (isStringArray(data)) return data.map((k) => k.trim()).filter(Boolean);
  if (data && typeof data === 'object') {
    const raw = data as Record<string, unknown>;
    if (isStringArray(raw.granted)) return extractGranted(raw.granted);
    if (isStringArray(raw.permisos)) return extractGranted(raw.permisos);
    if (isStringArray(raw.keys)) return extractGranted(raw.keys);
  }
  return [];
}

function normalizeCatalogo(data: unknown): PermisoCatalogo {
  const raw = data as PermisoCatalogo | undefined;
  if (!raw || !Array.isArray(raw.modulos)) {
    throw new Error('Catálogo de permisos inválido');
  }
  return { modulos: raw.modulos };
}

const permisoUsuarioService = {
  getCatalogo: async (): Promise<PermisoCatalogo> => {
    const response = await api.get('/api/seguridad/catalogo');
    return normalizeCatalogo(response.data);
  },

  getMatriz: async (username: string): Promise<MatrizUsuario> => {
    const user = username.trim();
    if (!user) return { username: user, granted: [] };
    const response = await api.get(`/api/Users/${encodeURIComponent(user)}/permisos`);
    return { username: user, granted: extractGranted(response.data) };
  },

  saveMatriz: async (username: string, granted: string[]): Promise<void> => {
    const user = username.trim();
    if (!user) return;
    await api.put(`/api/Users/${encodeURIComponent(user)}/permisos`, {
      username: user,
      granted,
    });
  },
};

export default permisoUsuarioService;
